import { LoginState } from "../../types/state.types";
import { setSession } from "../../utils/session-helper";
import { StoreAction } from "../reduxTypes";
import * as actions from "./actions";

const initialState: LoginState = {
  logged: false,
  userData: undefined,
  loading: false,
  modalOpen: false,
};

const reducer = (
  state: LoginState = initialState,
  action: StoreAction
): LoginState => {
  switch (action.type) {
    case actions.SESSION__INIT_LOGIN_STATE:
      return {
        ...state,
        ...action.payload,
      };

    case actions.SESSION__START_LOGIN_LOAD:
      return {
        ...state,
        loading: true,
      };

    case actions.SESSION__STOP_LOGIN_LOAD:
      return {
        ...state,
        loading: false,
      };

    case actions.SESSION__MODAL_OPEN:
      return {
        ...state,
        modalOpen: action.payload,
      };

    case actions.SESSION__SET_SESSION:
      setSession({ userData: state.userData, logged: true });
      return {
        ...state,
        logged: true,
      };

    case actions.SESSION__SET_TEMP_SESSION:
      return {
        ...state,
        userData: action.payload,
      };

    case actions.SESSION__LOGOUT:
      setSession({ userData: undefined, logged: false });
      return {
        ...state,
        userData: undefined,
        logged: false,
      };

    default:
      return state;
  }
};

export default reducer;
